import { render, staticRenderFns } from "./SidebarBank.vue?vue&type=template&id=54aa1a5e&scoped=true&"
import script from "./SidebarBank.vue?vue&type=script&lang=js&"
export * from "./SidebarBank.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBank.vue?vue&type=style&index=0&id=54aa1a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa1a5e",
  null
  
)

export default component.exports